"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dompurify = _interopRequireWildcard(require("dompurify"));
var _environment = require("../environment");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var stringSanitize = _dompurify.sanitize;
if ((0, _environment.getClientEnvironmentDetails)().isNode) {
  var _require = require('jsdom'),
    JSDOM = _require.JSDOM; // eslint-disable-line

  var _JSDOM = new JSDOM(''),
    window = _JSDOM.window;
  var DOMPurify = (0, _dompurify.default)(window);
  stringSanitize = DOMPurify.sanitize;
}
var _default = exports.default = stringSanitize;
module.exports = exports.default;
//# sourceMappingURL=sanitizeString.js.map